import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=74b4f555&"
import script from "./Result.vue?vue&type=script&lang=ts&"
export * from "./Result.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports